import { c as _c } from "react/compiler-runtime";
import { Box } from "@mui-wrapper";
import { PALETTE_VARS } from "@styles/palette-vars";
import { border } from "@utils/ui-utils";
/** A section below the details of the user in the profile card, set apart by a line above it */
export function UserInfoSection(t0) {
  const $ = _c(3);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      marginX: 3,
      borderTop: border(PALETTE_VARS.divider),
      paddingY: 3
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== children) {
    t2 = <Box sx={t1}>{children}</Box>;
    $[1] = children;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}